module.exports = __webpack_public_path__ + "media/images/element3-8cb5cff96b545af938fee5aa61c9ffa7.png";